module.exports = __webpack_public_path__ + "img/sofa.fe4708a1.svg";